/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResponseForAgentTable extends models.BaseForAgentResponse {
    constructor() {
        super();
        this.setDiscriminator("Table");
    }

    getFixupPrototypeFunction() { return ResponseForAgentTable.fixupPrototype; }

    static newInstance(model: Partial<ResponseForAgentTable>): ResponseForAgentTable {
        let obj = Object.assign(new ResponseForAgentTable(), model);
        ResponseForAgentTable.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResponseForAgentTable>): ResponseForAgentTable {
        if (!model) return null;
        return ResponseForAgentTable.newInstance(<ResponseForAgentTable> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResponseForAgentTable) {
        if (!obj) return;

        models.ResponseForAgentTable.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResponseForAgentTable): boolean {
        if (models.BaseForAgentResponse.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResponseForAgentTable.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.value) {
            models.AgentTableData.fixupPrototype(this.value);
        }
    }

    /**
     * Table response
     */
    value: models.AgentTableData;

}
